import { PaymentStatus, TaskPaymentStatus } from '@admiin-com/ds-graphql';

export const PAYABLE_TASK_STATUSES: TaskPaymentStatus[] = [
  TaskPaymentStatus.MARKED_AS_PAID,
  TaskPaymentStatus.DECLINED,
  TaskPaymentStatus.PENDING_PAYMENT,
];

const PAYABLE_TASK_STATUS_SET = new Set(PAYABLE_TASK_STATUSES);

export const isTaskPayable = (
  status?: TaskPaymentStatus | null
): status is TaskPaymentStatus => {
  if (!status) {
    return false;
  }

  return PAYABLE_TASK_STATUS_SET.has(status);
};

export const PAYABLE_PAYMENT_STATUSES: PaymentStatus[] = [
  PaymentStatus.GUEST_SCHEDULED,
  PaymentStatus.SCHEDULED,
  PaymentStatus.DECLINED,
  PaymentStatus.PAYMENT_PENDING,
  PaymentStatus.PAYMENT_REQUIRED,
];

const PAYABLE_PAYMENT_STATUS_SET = new Set(PAYABLE_PAYMENT_STATUSES);

export const isPaymentPayable = (
  status?: PaymentStatus | null
): status is PaymentStatus => {
  if (!status) {
    return false;
  }

  return PAYABLE_PAYMENT_STATUS_SET.has(status);
};
